<template>
	<div v-if="!connected">
		<v-chip color="white" class="px-6" text-color="white" large @click="connectWalletLogin" >
			<span class="black--text">CONNECT WALLET</span>
		</v-chip>
	</div>
	<div v-else>
		<v-menu class="d-block" offset-y rounded>
			<template v-slot:activator="{ on, attrs }">
				<v-chip color="systemdarkgray" text-color="white" large v-on="on" v-bind="attrs">
					<v-avatar color="secondary" class="p-5" size="32">
						<span class="white--text">0x</span>
					</v-avatar>
					<span class="px-2">{{ wallet == undefined ? "" : wallet.slice(-5) }}</span>
				</v-chip>
			</template>
			<v-list>
				<v-list-item link @click="disconnectWallet">
					<v-list-item-title>Disconnect</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>
<script>
export default {
	props: {
		wallet: String,
		connected: Boolean
	},
	mounted() {
	},
	methods: {
		connectWalletLogin() {
			this.$emit('connect');
		},
		disconnectWallet() {
			this.$emit('disconnect');
		},
	},
}
</script>